import {Injectable} from '@angular/core';
import {
  IPlatformCommandHandler,
  IPlatformToolHandler
} from '@shared/components/platform-tool/platform-tool-container/platform-tool-component';
import {DialogService} from '@shared/services/dialog-service';
import {PlatformCommand} from '@shared/commands/command-base';
import {take} from 'rxjs/operators';

/**
 * "Create Xact Script" in a folder's Premium Features menu (XAT-E-268-01).
 *
 * The same two-step the QNR create uses: ask for the name here, then re-dispatch the backend's own command
 * with it. The server owns everything after that - the XACT-ID, the stub entry and the empty code.xact -
 * so this handler knows nothing about them.
 */
@Injectable({
  providedIn: 'root',
})
export class CreateXactScriptCommandHandler implements IPlatformCommandHandler {
  constructor(
    private dialogService: DialogService
  ) {
  }

  executeCommand(command: PlatformCommand, handler: IPlatformToolHandler, callback?: any): boolean {
    this.dialogService.showTextInputDialog('Xact Script Name', '')
      .pipe(take(1))
      .subscribe(state => {
        if (state.action === 'OK') {
          // Title, because that is the field CreateXactScriptCommandConsumer reads the name from.
          command.fieldValues['Title'] = state.data.input.text;
          handler.executeCommand(command);
        }
      });
    return true;
  }
}
